export default function getCurrentLocale(state) {
    return state.i18n.locale;
}
